import { useCallback } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { PaymentFilters, PaymentStatus } from '../types';

const defaults: PaymentFilters = {
  s: undefined,
  limit: 10,
  page: 0,
  orderBy: 'createdAt',
  order: 'desc',
  'createdAt.min': undefined,
  'createdAt.max': undefined,
  'paidAt.min': undefined,
  'paidAt.max': undefined,
  status: undefined,
  billId: undefined,
  contractId: undefined,
  clientId: undefined,
  methodId: undefined,
  unallocated: undefined,
};

const numberFields: (keyof PaymentFilters)[] = [
  'limit',
  'page',
  'billId',
  'contractId',
  'clientId',
  'methodId',
];
const booleanFields: (keyof PaymentFilters)[] = ['unallocated'];

export function usePaymentFilters() {
  const { updateFilter, ...rest } = useUrlFilters<PaymentFilters>({
    defaults,
    numberFields,
    booleanFields,
  });

  const setStatus = useCallback(
    (status: PaymentStatus | undefined) => updateFilter('status', status, true),
    [updateFilter]
  );

  const setSearch = useCallback(
    (search: string) => updateFilter('s', search || undefined, true),
    [updateFilter]
  );

  return { ...rest, updateFilter, setStatus, setSearch };
}
